import { Link } from 'react-router-dom';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function PolicyLayout({ title, updated, intro, children }) {
  return (
    <main className="policy">
      <div className="policy__hero">
        <div className="shell">
          <p className="policy__crumbs">
            <Link to="/">Home</Link>
            <span aria-hidden="true"> / </span>
            <span>{title}</span>
          </p>
          <h1>{title}</h1>
          {updated ? <p className="policy__updated">Last updated: {updated}</p> : null}
        </div>
      </div>

      <div className="shell policy__body">
        <article className="policy__card">
          {intro ? <p className="policy__intro">{intro}</p> : null}
          {children}

          <h2>Need help?</h2>
          <p>
            If anything on this page is unclear, call {SUPPORT_PHONE_LABEL} or start a live
            chat and we will talk it through.
          </p>
          <div className="section__actions" style={{ justifyContent: 'flex-start' }}>
            <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
              Call {SUPPORT_PHONE_LABEL}
            </a>
            <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
              Live Chat
            </button>
          </div>
        </article>
      </div>
    </main>
  );
}
